module.exports = __webpack_public_path__ + "img/teamwork.8978a072.jpg";